import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {navigateTo} from '../../lib/nav.js';
import styles from './new-project-popup.css';

class NewProjectPopup extends React.Component {
    constructor (props) {
        super(props);
        this.handleOverlayClick = this.handleOverlayClick.bind(this);
    }
    handleOverlayClick (e) {
        if (e.target === e.currentTarget) {
            this.props.onClose();
        }
    }
    handleBlockProject () {
        navigateTo('/editor');
    }
    handleCodeProject () {
        navigateTo('/ide');
    }
    render () {
        const modalElement = (
            <div
                className={styles.modalOverlay}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 999999,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                    padding: '1.5rem',
                    boxSizing: 'border-box'
                }}
                onClick={this.handleOverlayClick}
            >
                <div
                    className={styles.modalContent}
                    style={{
                        margin: 'auto',
                        maxWidth: '92vw',
                        maxHeight: '85vh',
                        boxSizing: 'border-box'
                    }}
                >
                    <button
                        className={styles.closeButton}
                        onClick={this.props.onClose}
                    >
                        {'\u00D7'}
                    </button>

                    <h2 className={styles.modalTitle}>New Project</h2>
                    <p className={styles.modalSubtitle}>Choose what kind of project you want to create</p>

                    <div className={styles.cardsRow}>
                        <div
                            className={styles.projectCard}
                            onClick={this.handleBlockProject}
                            role="button"
                            tabIndex="0"
                            onKeyDown={e => { if (e.key === 'Enter') this.handleBlockProject(); }}
                        >
                            <div className={`${styles.cardIcon} ${styles.blockIcon}`}>
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="3" width="7" height="7" rx="1.5" fill="#d4748c" />
                                    <rect x="14" y="3" width="7" height="7" rx="1.5" fill="#d4748c" opacity="0.6" />
                                    <rect x="3" y="14" width="7" height="7" rx="1.5" fill="#d4748c" opacity="0.6" />
                                    <rect x="14" y="14" width="7" height="7" rx="1.5" fill="#d4748c" opacity="0.4" />
                                </svg>
                            </div>
                            <p className={styles.cardTitle}>Block Project</p>
                            <p className={styles.cardDescription}>
                                Drag-and-drop blocks to build interactive projects with the Scratch editor
                            </p>
                        </div>

                        <div
                            className={styles.projectCard}
                            onClick={this.handleCodeProject}
                            role="button"
                            tabIndex="0"
                            onKeyDown={e => { if (e.key === 'Enter') this.handleCodeProject(); }}
                        >
                            <div className={`${styles.cardIcon} ${styles.codeIcon}`}>
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                                    <path d="M8 18L2 12L8 6" stroke="#648cdc" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M16 6L22 12L16 18" stroke="#648cdc" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M14 4L10 20" stroke="#648cdc" strokeWidth="2" strokeLinecap="round" opacity="0.5" />
                                </svg>
                            </div>
                            <p className={styles.cardTitle}>Code Project</p>
                            <p className={styles.cardDescription}>
                                Write code with a full IDE featuring editor, terminal, and live preview
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );

        if (typeof document !== 'undefined' && document.body) {
            return ReactDOM.createPortal(modalElement, document.body);
        }
        return modalElement;
    }
}

NewProjectPopup.propTypes = {
    onClose: PropTypes.func.isRequired
};

export default NewProjectPopup;
